/** Lowercase, punctuation-free, hyphen-separated form of a name, for use as a URL slug. */
export const toSlug = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const convertCamelCaseToSentence = (value: string) => {
  return value.replace(/([A-Z])/g, " $1").trim();
};

export const convertCamelCaseToHyphenated = (value: string) => {
  return value
    .trim()
    .replace(/([A-Z])/g, "-$1")
    .toLowerCase();
};

export const removeFileExtension = (value: string) => {
  const dotIndex = value.lastIndexOf(".");

  return dotIndex !== -1 ? value.substring(0, dotIndex) : value;
};

export const isValidDomainName = (value: string) => {
  const domainNameRegex =
    /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
  return domainNameRegex.test(value);
};

export const getAnalysisTypeName = (isLargeSite: boolean, isPlural: boolean = false): string => {
  const pluralSuffix = isPlural ? "s" : "";
  const value = isLargeSite ? "point" : "asset";
  return `${value}${pluralSuffix}`;
};

export const formatSettingSwitchValue = (isEnabled: string | boolean | null | undefined): string =>
  isEnabled ? "Enabled / On" : "Disabled / Off";
